import {
    setInsertLinksTaskId,
    cancelInsertLinks,
    onInsertLinksDone,
} from '../actions/internalActions';
import { getStore } from '../store/store';
import { InsertLinksNotActive } from '../utils/constants';
import { mutator } from 'satcheljs';
import { trace } from 'owa-trace';

mutator(setInsertLinksTaskId, actionMessage => {
    trace.info('setInsertLinksTaskId');
    const store = getStore();
    const { newValue } = actionMessage;
    store.insertLinksTaskId = newValue;
});

mutator(cancelInsertLinks, actionMessage => {
    trace.info('cancelInsertLinks');
    const store = getStore();
    store.insertLinksTaskId = InsertLinksNotActive;
});

mutator(onInsertLinksDone, actionMessage => {
    trace.info('onInsertLinksDone');
    const store = getStore();
    store.insertLinksTaskId = InsertLinksNotActive;
});
